import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  Icon,
  Center,
  Spinner,
} from '@chakra-ui/react'
import { LuUsers, LuCrown } from 'react-icons/lu'
import { useMyTeam } from '../../api/api_hooks/lab/myTeam'
import { useTranslation } from 'react-i18next'

/**
 * "Mon équipe" — shown to a collaborateur (not a chef): who invited them,
 * and who else is on the same team. Mirrors CollaboratorsPanel (the chef's
 * own view), but from the other side. Hidden entirely for a chef or a
 * standalone user (isCollaborator: false).
 */
export default function MyTeamPanel() {
  const { t } = useTranslation()
  const { data, isLoading } = useMyTeam()

  if (isLoading) {
    return (
      <Box bg="white" borderRadius="2xl" border="1px solid" borderColor="gray.100" boxShadow="sm" p={5}>
        <Center py={2}><Spinner size="sm" color="blue.400" /></Center>
      </Box>
    )
  }

  if (!data?.isCollaborator || !data.chef) return null

  const others = (data.members ?? []).filter((m) => !m.isMe)

  return (
    <Box bg="white" borderRadius="2xl" border="1px solid" borderColor="gray.100" boxShadow="sm" p={5}>
      <HStack spacing={2} mb={3}>
        <Icon as={LuUsers} boxSize={4} color="gray.500" />
        <Text fontWeight="700" fontSize="sm" color="gray.800">{t('profile.myTeam.title')}</Text>
      </HStack>

      <HStack justify="space-between" fontSize="xs" px={1} py={1} mb={others.length > 0 ? 2 : 0}>
        <HStack spacing={2}>
          <Icon as={LuCrown} boxSize={3.5} color="orange.400" />
          <Text color="gray.700">{data.chef.contactName || data.chef.email}</Text>
        </HStack>
        <Badge colorScheme="orange" variant="subtle" fontSize="2xs">Chef</Badge>
      </HStack>

      {others.length > 0 && (
        <VStack spacing={2} align="stretch">
          {others.map((m) => (
            <HStack key={m.email} justify="space-between" fontSize="xs" px={1} py={1}>
              <VStack spacing={0} align="start">
                <Text color="gray.700">{m.email}</Text>
                {m.jobTitle && <Text color="gray.400" fontSize="2xs">{m.jobTitle}</Text>}
              </VStack>
              <Badge
                colorScheme={m.status === 'accepted' ? 'green' : 'orange'}
                variant="subtle"
                fontSize="2xs"
              >
                {m.status === 'accepted' ? t('profile.collaborators.active') : t('profile.collaborators.pending')}
              </Badge>
            </HStack>
          ))}
        </VStack>
      )}

      <Text fontSize="2xs" color="gray.400" mt={3}>
        Seul(e) {data.chef.contactName || data.chef.email} peut inviter de nouveaux collaborateurs.
      </Text>
    </Box>
  )
}
